document.addEventListener("DOMContentLoaded", () => {});
// document.addEventListener("DOMContentLoaded", function () {
//   const priceElement = document.querySelector("[data-product-price]");

//   if (!priceElement) {
//     console.warn("Price element not found.");
//     return;
//   }

//   // Listen for a custom event (or use the theme's existing event system)
//   document.addEventListener("variant:change", function (event) {
//     const variant = event.detail.variant;

//     if (!variant) {
//       // If no variant is selected, display an "Unavailable" message
//       priceElement.innerHTML = '<span class="unavailable">Price Unavailable</span>';
//       priceElement.setAttribute("data-product-price", "");
//       return;
//     }

//     // Format price
//     const formattedPrice = Shopify.formatMoney(variant.price, "{{ amount_with_currency }}");
//     const formattedComparePrice = variant.compare_at_price
//       ? Shopify.formatMoney(variant.compare_at_price, "{{ amount_with_currency }}")
//       : null;

//     // Update price element
//     if (variant.compare_at_price > variant.price) {
//       priceElement.innerHTML = `<del>${formattedComparePrice}</del> <ins>${formattedPrice}</ins>`;
//     } else {
//       priceElement.innerHTML = `<ins>${formattedPrice}</ins>`;
//     }

//     // Update attributes
//     priceElement.setAttribute("data-product-price", variant.price);
//     priceElement.setAttribute(
//       "data-saletype",
//       variant.compare_at_price > variant.price ? "1" : "0"
//     );
//   });

//   // Example: Trigger the event manually (replace with your theme's logic)
//   const variantSelectors = document.querySelectorAll(".variant-selector");
//   variantSelectors.forEach((selector) => {
//     selector.addEventListener("change", function () {
//       const selectedVariant = /* Logic to get selected variant */;
//       const event = new CustomEvent("variant:change", { detail: { variant: selectedVariant } });
//       document.dispatchEvent(event);
//     });
//   });
// });
